jQuery( document ).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '800',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

});

(function() {
  var elements;
  var windowHeight;

  function init() {
    elements = document.querySelectorAll('.hidden');
    windowHeight = window.innerHeight;
  }

  function checkPosition() {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var positionFromTop = elements[i].getBoundingClientRect().top;

      if (positionFromTop - windowHeight <= 0) {
        element.classList.add('fade-in-element');
        element.classList.remove('hidden');
      }
      else {
        element.classList.remove('fade-in-element');
        element.classList.add('hidden');
      }
    }
  }

  window.addEventListener('scroll', checkPosition);
  window.addEventListener('resize', init);

  init();
  checkPosition();
})();

$(document).ready(function(){
	$(window).scroll(function () {
			if ($(this).scrollTop() > 500) {
				$('#back-to-top').fadeIn();
        $('#pageSideMenu').fadeIn();
			} else {
				$('#back-to-top').fadeOut();
        $('#pageSideMenu').fadeOut();
			}
		});
		// scroll body to 0px on click back to top button
		$('#back-to-top').click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 400);
			return false;
		});
    
});

//Disable right click on images with noselect class
$('img.noselect').each(function() {
  $(this)[0].oncontextmenu = function() {
    return false;
  };
});

//Toggle mobile icon to close when menu is open
$( "#nav-items" ).on( "click", function() {
  $("svg", this).toggleClass("fa-bars fa-times");
}); 

//Function for fixed header position to stop scrolling at a certain point
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    $('active').removeClass('active');
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({scrollTop: target.offset().top-100}, 0);
      return false;
      }
    }
  });
});




//Wrap section around 
$('a[class="content-anchor"]').each(function(){
  var hashName = $(this).attr('name');
  //wrap section with anchor tag and make name the id
  $(this).parents('.section').wrap("<section id=" + hashName +" ></section>");
});



$(document).ready(function(){
  var sectionIds = $('#pageSideMenu a');
    $(document).scroll(function(){
        sectionIds.each(function(){

            var container = $(this).attr('href');          
            var containerOffset = $(container).offset().top-170;
            var containerHeight = $(container).outerHeight();
            var containerBottom = containerOffset + containerHeight;
            var scrollPosition = $(document).scrollTop();
    
            if(scrollPosition < containerBottom-20  && scrollPosition >= containerOffset-20 ){
                $(this).addClass('active');
            } else{
                $(this).removeClass('active');
            }
       
        });
    });
   


});

$('.counter').each(function() {
  var $this = $(this),
    countTo = $this.attr('data-count');

  $({
    countNum: $this.text()
  }).animate({
      countNum: countTo
    },

    {
      duration: 5000,
      easing: 'linear',
      step: function() {
        $this.text(commaSeparateNumber(Math.floor(this.countNum)));
      },
      complete: function() {
        $this.text(commaSeparateNumber(this.countNum));
        //alert('finished');
      }
    }
  );

});

function commaSeparateNumber(val) {
  while (/(\d+)(\d{3})/.test(val.toString())) {
    val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
  }
  return val;
}